import { render } from "./NotSupported.vue?vue&type=template&id=12136534&scoped=true"
import script from "./NotSupported.vue?vue&type=script&setup=true&lang=js"
export * from "./NotSupported.vue?vue&type=script&setup=true&lang=js"

import "./NotSupported.vue?vue&type=style&index=0&id=12136534&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12136534"],['__file',"resources/js/components/whatsapp-managment/includes/types/NotSupported.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12136534"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12136534', __exports__)) {
    console.log('reload')
    api.reload('12136534', __exports__)
  }
  
  module.hot.accept("./NotSupported.vue?vue&type=template&id=12136534&scoped=true", () => {
    console.log('re-render')
    api.rerender('12136534', render)
  })

}


export default __exports__